import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_BLACK, COLOR_ORANGE } from '../../assets/styles/colors';
import { BP_MOBILE_MAX, BP_TABLET_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  justify-content: flex-start;
  padding-bottom: 0px;
  @media (max-width: ${BP_TABLET_MAX}px) {
    max-width: 560px;
    margin: 0 auto;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const OtherFaqsSC = styled.div`
  margin-right: 50px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 300px);
  flex-wrap: wrap;
  max-width: 247px;
  flex: 1;
  padding-right: 50px;
  border-right: 1px solid ${rgba('#0b0217', 0.3)};
  button {
    margin-bottom: 20px;
    &.active {
      color: ${COLOR_BLACK};
      text-decoration: none;
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    flex: none;
    margin-right: 30px;
    padding-right: 30px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 300px);
    flex-wrap: wrap;
    max-width: calc(30% - 30px);
    width: 100%;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    width: 100%;
    min-height: auto;
    border-bottom: 1px solid ${rgba('#0b0217', 0.3)};
    border-right: none;
    margin-right: 0px;
    padding-right: 0px;
    margin-bottom: 20px;
  }
`;

export const DetailSC = styled.div`
  flex: 2;
  .answer-headline {
    display: block;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 16px;
  }
  a {
    color: ${COLOR_ORANGE};
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    flex: none;
    max-width: calc(70% - 20px);
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    width: 100%;
    overflow-wrap: break-word;
  }
`;
